import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=5ca11879"
import script from "./GenericDialog.vue?vue&type=script&lang=js"
export * from "./GenericDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports